import VConsole from 'vconsole' 

export default defineNuxtPlugin((nuxtApp) => {
    // const vc = new VConsole();
    // nuxtApp.vueApp.use(vc)
})
